// extracted by mini-css-extract-plugin
module.exports = {"ratingsCompact":"RatingsCompact_ratingsCompact__YxhU_","starRated":"RatingsCompact_starRated__tlmFK"};